@if (vm$ | async; as vm) {
    @if (vm.title && !vm.hideMarketHeader) {
        <div class="pod-outrights-header">
            <span class="header-title" [title]="vm.title">
                {{ vm.title }}
            </span>
        </div>
    }

    <div
        class="option-group-container"
        msOptionGroupRenderer
        [maxColumns]="4"
        [tolerance]="50"
        [responsiveColumns]="responsiveColumns"
        [resetClass]="true"
        [optionGroup]="vm.optionGroup"
        [optionPickClass]="'.option-group'">
        @for (option of vm.optionGroup.options | slice: 0 : vm.visibleOptionsLimit; let optionIndex = $index; track option.id) {
            <div class="option-group">
                <ms-participant-image [showFallback]="true" [participantImage]="vm.optionImages[option.id]" [sportId]="vm.event.sport.id" />
                <span class="name">{{ option.name }}</span>
                <ms-option
                    [optionGroup]="vm.optionGroup"
                    [option]="option"
                    [event]="vm.event"
                    [tracking]="{ source: vm.trackingSource, position: optionIndex, moduleType: trackingModuleType }"
                    [sourceOfPick]="sourceOfPick" />
            </div>
        }
    </div>
    @if (vm.showMoreLessButtonVisible && vm.optionGroup?.online) {
        <div class="show-more-less-button" (click)="showMore()">
            {{ sitecore.event.ShowMore }}
            <vn-icon class="icon-alignment" name="theme-down" size="14" />
        </div>
    }

    @if (vm.expanded && vm.optionGroup?.online && vm.showAllWagersLink) {
        <div class="all-markets-link">
            <ms-item [href]="vm.eventUrl" (itemClicked)="trackBottomLink()">
                <span item-title>{{ sitecore.event.SeeAll }}</span>
            </ms-item>
        </div>
    }
}
